<rm-retail-media-products-search
    #search
    class="search"
    [selectedProducts]="form.value"
    [campaignType]="campaignType"
    (onSelect)="onSelect($event)"
    (onRemove)="onRemove($event)"
/>
<rm-retail-media-products-selected
    class="selected"
    [selectedProducts]="form.value"
    (onRemove)="onRemove($event)"
    (onClear)="onClear()"
    (onSelectCampaign)="onSelectCampaign($event)"
    [recentCampaigns]="recentCampaigns"
    [lastCampaignsLoading]="lastCampaignsLoading"
    [isRetailMediaInventoryCampaign]="campaignType === CampaignType.RETAIL_MEDIA_INVENTORY"
/>
<div class="next">
    <ng-content />
</div>
